export * from './ingredientsInfo';
